const RolePermTypes = {
  GET_ROLEPERM_LIST_REQUEST: 'GET_ROLEPERM_LIST_REQUEST',
  GET_ROLEPERM_LIST_SUCCESS: 'GET_ROLEPERM_LIST_SUCCESS',
  GET_ROLEPERM_LIST_ERROR: 'GET_ROLEPERM_LIST_ERROR',

  ADD_ROLEPERM_REQUEST: 'ADD_ROLEPERM_REQUEST',
  ADD_ROLEPERM_SUCCESS: 'ADD_ROLEPERM_SUCCESS',
  ADD_ROLEPERM_ERROR: 'ADD_ROLEPERM_ERROR',

  GET_ROLEPERM_ITEM_REQUEST: 'GET_ROLEPERM_ITEM_REQUEST',
  GET_ROLEPERM_ITEM_SUCCESS: 'GET_ROLEPERM_ITEM_SUCCESS',
  GET_ROLEPERM_ITEM_ERROR: 'GET_ROLEPERM_ITEM_ERROR',

  UPDATE_ROLEPERM_REQUEST: 'UPDATE_ROLEPERM_REQUEST',
  UPDATE_ROLEPERM_SUCCESS: 'UPDATE_ROLEPERM_SUCCESS',
  UPDATE_ROLEPERM_ERROR: 'UPDATE_ROLEPERM_ERROR',

  DELETE_ROLEPERM_REQUEST: 'DELETE_ROLEPERM_REQUEST',
  DELETE_ROLEPERM_SUCCESS: 'DELETE_ROLEPERM_SUCCESS',
  DELETE_ROLEPERM_ERROR: 'DELETE_ROLEPERM_ERROR',

  GET_ROLEPERM_ACTIVE_REQUEST: 'GET_ROLEPERM_ACTIVE_REQUEST',
  GET_ROLEPERM_ACTIVE_SUCCESS: 'GET_ROLEPERM_ACTIVE_SUCCESS',
  GET_ROLEPERM_ACTIVE_ERROR: 'GET_ROLEPERM_ACTIVE_ERROR',

  GET_ROLE_BASED_USER_REQUEST: 'GET_ROLE_BASED_USER_REQUEST',
  GET_ROLE_BASED_USER_SUCCESS: 'GET_ROLE_BASED_USER_SUCCESS',
  GET_ROLE_BASED_USER_ERROR: 'GET_ROLE_BASED_USER_ERROR',

  UPDATE_ROLE_QUERY_PARAMS: 'UPDATE_ROLE_QUERY_PARAMS',

  // Permissions

  GET_ALL_PERMISSION_REQUEST: 'GET_ALL_PERMISSION_REQUEST',
  GET_ALL_PERMISSION_SUCCESS: 'GET_ALL_PERMISSION_SUCCESS',
  GET_ALL_PERMISSION_ERROR: 'GET_ALL_PERMISSION_ERROR',

  GET_PERMISSION_REQUEST: 'GET_PERMISSION_REQUEST',
  GET_PERMISSION_SUCCESS: 'GET_PERMISSION_SUCCESS',
  GET_PERMISSION_ERROR: 'GET_PERMISSION_ERROR',

  ASSIGN_PERMISSION_REQUEST: 'ASSIGN_PERMISSION_REQUEST',
  ASSIGN_PERMISSION_SUCCESS: 'ASSIGN_PERMISSION_SUCCESS',
  ASSIGN_PERMISSION_ERROR: 'ASSIGN_PERMISSION_ERROR',

  GET_USER_PERMISSION_REQUEST: 'GET_USER_PERMISSION_REQUEST',
  GET_USER_PERMISSION_SUCCESS: 'GET_USER_PERMISSION_SUCCESS',
  GET_USER_PERMISSION_ERROR: 'GET_USER_PERMISSION_ERROR',

  GET_CURRENT_USER_PERMISSION_REQUEST: 'GET_CURRENT_USER_PERMISSION_REQUEST',
  GET_CURRENT_USER_PERMISSION_SUCCESS: 'GET_CURRENT_USER_PERMISSION_SUCCESS',
  GET_CURRENT_USER_PERMISSION_ERROR: 'GET_CURRENT_USER_PERMISSION_ERROR'
};
export default RolePermTypes;
